import { useQuery } from "@tanstack/react-query";
import { api } from "../data/api";

interface BatchSummary {
  id: string;
  status: string;
  counts: { remaining: number };
}

/** Rows still to review across pending import batches. Zero when offline. */
export function usePendingImports(): number {
  const { data } = useQuery({
    queryKey: ["import-batches"],
    queryFn: () => api<{ batches: BatchSummary[] }>("/import-batches"),
    retry: false,
    staleTime: 30_000,
  });
  return (data?.batches ?? [])
    .filter((b) => b.status === "pending")
    .reduce((s, b) => s + b.counts.remaining, 0);
}
